var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedditFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.39 89.53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.22 60.4a7.36 7.36 0 117.36-7.4 7.37 7.37 0 01-7.36 7.36m1.66 13c-5.23 5.22-15.25 5.63-18.19 5.63s-13-.41-18.2-5.63a2 2 0 112.81-2.81c3.3 3.3 10.34 4.47 15.39 4.47s12.09-1.17 15.38-4.47a2 2 0 012.81 2.81M25.15 53.19a7.36 7.36 0 117.36 7.36 7.37 7.37 0 01-7.36-7.36m73.55-7.66a10.72 10.72 0 00-18.17-7.71c-7.32-5.29-17.43-8.7-28.68-9.1l4.88-23 16 3.4a7.67 7.67 0 10.78-3.75L55.64 1.58a1.92 1.92 0 00-1.44.27 1.89 1.89 0 00-.82 1.2S48 28.56 48 28.7c-11.46.3-21.76 3.73-29.2 9.09A10.72 10.72 0 107 55.31a21.81 21.81 0 00-.25 3.25c0 16.5 19.21 29.87 42.91 29.87s42.9-13.37 42.9-29.87a21.51 21.51 0 00-.25-3.22 10.78 10.78 0 006.36-9.81",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/reddit_full.d29aab7eb155898f2bd9570605c4f01a.svg";
export { SvgRedditFull as ReactComponent };